import React, { FC, ReactNode, useRef } from 'react';
import { Popup } from '@shared/uikit/popup';
import { DarkGrayButton, GrayButton } from '@shared/uikit/button';
import { Loader } from '@shared/uikit/loader';
import { IAccount } from '@entities/account/IAccount';

interface IProps {
  account: IAccount | null;
  onClose: () => void;
  onSubmit: () => void;
  children: ReactNode | ReactNode[];
  isLoading: boolean;
  isSubmitting: boolean;
}

const BaseAccountPopupEdit: FC<IProps> = ({
  onClose,
  onSubmit,
  children,
  account,
  isLoading,
  isSubmitting,
}) => {
  const submitRef = useRef<HTMLInputElement>(null);

  return (
    <Popup open={true} onClose={onClose} width="550px">
      {!isLoading && account ? (
        <>
          <form onSubmit={onSubmit}>
            {children}
            <input
              type="submit"
              ref={submitRef}
              disabled={isSubmitting}
              style={{ display: 'none' }}
            />
          </form>
          <div className="text-left flex items-center justify-end pt-[15px]">
            <div className="text-[white] flex gap-[10px]">
              <GrayButton
                type="submit"
                onClick={() => submitRef?.current?.click()}
                title={isSubmitting ? <Loader size={30} loading={isSubmitting} /> : 'Сохранить'}
              />
            </div>
          </div>
        </>
      ) : (
        <div className="flex items-center justify-center min-h-[150px]">
          <Loader size={30} loading={true} />
        </div>
      )}
      <></>
    </Popup>
  );
};

export default BaseAccountPopupEdit;
